// @ts-nocheck
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import constants from "@store/constants";
import { mapValuesPerBreakpoint } from "@store/Framework/Features/FieldDefinitionBuilder/Utilities/mapValuesPerBreakpoint";

/**
 *
 * @param values - The fields values
 * @return - An array of values by breakpoint
 */
export default (values: HasFields["fields"]) => {
    const breakpoints = [0, 600, 900, 1200, 1500]; // Do not change this, CMS content may be tied to the keys
    breakpoints.shift();

    if (breakpoints?.length) {
        return breakpoints?.map((x: number) => {
            return mapValuesPerBreakpoint(values, x);
        });
    }

    return [];
};
